// extracted by mini-css-extract-plugin
export default {"wrapper":"ButtonAvatar_wrapper__AGcAw"};